// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CorePricingContext from "./CorePricingContext.bs.js";

var make = CorePricingContext.context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

export {
  make ,
  makeProps ,
  
}
/* make Not a pure module */
